import { TextField, FormControl, InputLabel, MenuItem, Select, Accordion, AccordionSummary, Box, Typography, AccordionDetails } from '@material-ui/core';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import HelpIconButton from '../../../HelpIconButton';
import SingleDropDown from '../../../SingleDropDown';
import MultiDropDownObjects from '../../../MultiDropDownObjects';
import { useSpecificSetup } from '../../../../CustomHooks/useSpecificSetup';
import { formatOfficerName } from '../../../../utils/utils';
import CheckboxWithLabel from '../../../CheckboxWithLabel';
import CustomAutoComplete from '../../../CustomAutoComplete';

const booleanOptions = [
  { id: 1, name: '', value: null },
  { id: 2, name: 'True', value: 'true' },
  { id: 3, name: 'False', value: 'false' }
];

const StyledAccordionSummary = withStyles({
  root: {

    backgroundColor: props => props.nightmode === "true" ? '#616161' : '#fae8ad',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '0',
    },
  },
  expanded: {},
})(AccordionSummary);

const SearchForm = ({
  searchState,
  handleChange,
  handleSubmit,
  inputLabel,
  classes,
  nightMode,
  setup,
  showSearchOptions,
  setShowSearchOptions,
  SearchButtonsComponent,
  loading,
  setSearchResults,
  setShowModal,
  handleReset,
  resultsPerPage,
  setResultsPerPage,
  oriId,
  officers,
}) => {
  const { roadTypes, stateHighways } = setup.setupLists || {};
  const { areas } = useSpecificSetup(oriId)

  return (
    <Accordion data-testid="search-form" id="search-options-accordion" nightmode={nightMode?.toString()} square expanded={showSearchOptions} type="button" onChange={() => setShowSearchOptions(!showSearchOptions)} TransitionProps={{ unmountOnExit: false }}>
      <StyledAccordionSummary id="search-options-summary" nightmode={nightMode?.toString()} style={{ margin: 0 }} aria-controls="panel1d-content">
        <Box flexGrow="1" display="flex" justifyContent="space-between" >
          <Typography style={{ display: 'flex', alignItems: 'center', color: nightMode ? 'white' : '#303e4f', }} className={classes.expansionPanelTypography} data-cy="initial-call-information-panel-header">
            Size And Weight Search {showSearchOptions ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </Typography>
          <HelpIconButton objectname='mobile_size_and_weight_search' />
        </Box>
      </StyledAccordionSummary>
      <AccordionDetails data-testid="search-options-details" id="search-options-details" type="button" onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', flexDirection: 'column', padding: 0 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', height: 'auto', justifyContent: 'flex-start' }}>
            <FormControl variant="standard" className={classes.formControl}>
              <KeyboardDateTimePicker
                id="weigh-start-date-picker"
                InputLabelProps={{ shrink: true }}
                clearable
                showTodayButton
                disabled={false}
                label='Weigh Start'
                value={searchState.started_at_search_start_date}
                onChange={(date) => handleChange(date || "", "started_at_search_start_date")}
                format="MM/DD/YYYY HH:mm:ss"
                ampm={false}
              />
            </FormControl>
            <FormControl variant="standard" className={classes.formControl}>
              <KeyboardDateTimePicker
                id="weigh-end-date-picker"
                InputLabelProps={{ shrink: true }}
                clearable
                showTodayButton
                disabled={false}
                label='Weigh End'
                value={searchState.ended_at_search_end_date}
                onChange={(date) => handleChange(date || "", "ended_at_search_end_date")}
                format="MM/DD/YYYY HH:mm:ss"
                ampm={false}
              />
            </FormControl>
            <TextField
              name={'last-name'}
              inputProps={{ "id": "sw-last-name-input", "autoComplete": "off" }}
              InputProps={{ style: { borderRadius: '5px' } }}
              InputLabelProps={{ shrink: true, htmlFor: "sw-last-name-input" }}
              id="last-name-text-field"
              label="Last Name (or Company Name)"
              value={searchState.last_name}
              className={classes.matchMargin}
              onChange={(e) => handleChange(e.target.value, "last_name")}
            />
            <TextField
              name={'first-name'}
              inputProps={{ "id": "sw-first-name-input", "autoComplete": "off" }}
              InputProps={{ style: { borderRadius: '5px' } }}
              InputLabelProps={{ shrink: true, htmlFor: "sw-first-name-input" }}
              id="first-name-text-field"
              label="First Name"
              value={searchState.first_name}
              className={classes.matchMargin}
              onChange={(e) => handleChange(e.target.value, "first_name")}
            />
            <SingleDropDown
              id="violation-identified-dropdown"
              title={"Violation Identified"}
              labelStyle={{ color: nightMode ? 'white' : 'black', fontWeight: 'bold' }}
              value={searchState.violation_identified}
              options={booleanOptions}
              handleChange={(e) => handleChange(e.target.value, "violation_identified")}
              inputLabel={inputLabel}
              disabled={false}
              showBlank={false}
            />
            <SingleDropDown
              id="court-action-dropdown"
              title={"Court Action"}
              labelStyle={{ color: nightMode ? 'white' : 'black', fontWeight: 'bold' }}
              value={searchState.court_action}
              options={booleanOptions}
              handleChange={(e) => handleChange(e.target.value, "court_action")}
              inputLabel={inputLabel}
              disabled={false}
              showBlank={false}
            />
            <SingleDropDown
              id="dimension-violation-dropdown"
              title={"Dimension Violation"}
              labelStyle={{ color: nightMode ? 'white' : 'black', fontWeight: 'bold' }}
              value={searchState.dimension_violation_identified}
              options={booleanOptions}
              handleChange={(e) => handleChange(e.target.value, "dimension_violation_identified")}
              inputLabel={inputLabel}
              disabled={false}
              showBlank={false}
            />
            <MultiDropDownObjects
              id="road-types-dropdown"
              title={"Road Types"}
              stateName={"road_type_ids"}
              handleChange={(e) => handleChange(e.target.value, "road_type_ids")}
              selectedValues={searchState.road_type_ids}
              options={roadTypes}
              disabled={false}
              formStyle={classes.formControl}
              labelStyle={classes.multiInputLabel}
            />
            <MultiDropDownObjects
              id="highways-dropdown"
              title={"Highways"}
              stateName={"state_highway_ids"}
              handleChange={(e) => handleChange(e.target.value, "state_highway_ids")}
              selectedValues={searchState.state_highway_ids}
              options={searchState.road_type_ids?.length > 0 ? stateHighways.filter(hwy => searchState.road_type_ids.some(roadType => hwy.roadType?.name === roadType.name)) : stateHighways}
              disabled={false}
              formStyle={classes.formControl}
              labelStyle={classes.multiInputLabel}
            />
            <MultiDropDownObjects
              id="areas-dropdown"
              title={"Areas"}
              stateName={"area_ids"}
              handleChange={(e) => handleChange(e.target.value, "area_ids")}
              selectedValues={searchState.area_ids}
              options={areas}
              disabled={false}
              formStyle={classes.formControl}
              labelStyle={classes.multiInputLabel}
            />
            <CustomAutoComplete
              disableCloseOnSelect={true}
              disableClearable={true}
              autoSelect={false}
              minWidth={"250px"}
              addMargin={true}
              title={"Officers"}
              options={officers.sort((a, b) => {
                if (a?.personalAttribute?.lastName < b?.personalAttribute?.lastName) {
                  return -1
                } else {
                  return 1
                }
              })}
              loading={false}
              error={""}
              multiple={true}
              value={searchState?.officer_ids ? officers?.filter(option => searchState?.officer_ids?.some(ofc => option.id === ofc.id)) : []}
              nameFormatter={(option) => formatOfficerName(option)}
              stateName={"officer_ids"}
              updateFields={(value) => handleChange(value, "officer_ids")}
              id={"officer_ids"}
              setPausePolling={() => { }}
              disabled={false}
            />
            <CheckboxWithLabel
              checked={searchState?.primary}
              stateName={"primary"}
              onChange={(e) => handleChange(e.target.checked, "primary")}
              title={"Primary Officer"}
              formStyle={classes.formControl}
              disabled={false}
            />
            <div className={classes.matchMargin}>
              <InputLabel shrink={true} className={classes.label} data-cy={"results-per-page-label"} ref={inputLabel} id={"results-per-page-label"}>
                Results Per Page
              </InputLabel>
              <Select
                data-cy={"results-per-page-select"}
                id="results-per-page-select"
                name={"resultPerPage"}
                value={resultsPerPage || 10}
                native={false}
                onChange={(e) => setResultsPerPage(e.target.value)}
                style={{ marginTop: '0px', borderRadius: '5px' }}
              >
                <MenuItem data-cy={"10-results-per-page"} key={10} value={10}>10</MenuItem>
                <MenuItem data-cy={"25-results-per-page"} key={25} value={25}>25</MenuItem>
                <MenuItem data-cy={"50-results-per-page"} key={50} value={50}>50</MenuItem>
              </Select>
            </div>
          </div>
          <SearchButtonsComponent
            id="search-buttons"
            loading={loading}
            submitSearch={handleSubmit}
            setShowModal={setShowModal}
            resetSearchState={handleReset}
            clearSearchResults={() => setSearchResults(null)}
          />
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default SearchForm;
